import React from "react";
import RoutePaths from "security-app/routing/Routes";
import EventsPageNavigation from "components/events/EventsPageNavigation";
import useLicenseCheck from "license/useLicenseCheck";
import { EVENT_DEFINITIONS_TITLE } from "components/events/bindings";
import { DETECTION_CHAINS_TITLE } from "security-app/components/DetectionChains/constants";
import DetectionChainsPage from "./index";
export default {
  routes: [
    {
      path: RoutePaths.unqualified.CORE_EVENTS.DETECTION_CHAINS.LIST,
      component: () => /* @__PURE__ */ React.createElement(DetectionChainsPage, { navigationComponent: /* @__PURE__ */ React.createElement(EventsPageNavigation, null) })
    }
  ],
  pageNavigation: [
    {
      description: "Alerts",
      children: [
        {
          description: DETECTION_CHAINS_TITLE,
          titleKey: "enterprise_navigation:alerts.detection_chains",
          path: RoutePaths.CORE_EVENTS.DETECTION_CHAINS.LIST,
          // No permission gate: detection chains have no dedicated permission, and event-def access
          // is per-entity (share model). The list itself only shows chains the user can fully read.
          position: { after: EVENT_DEFINITIONS_TITLE },
          useCondition: () => {
            const {
              security: { isValid: isValidSecurityLicense }
            } = useLicenseCheck();
            return isValidSecurityLicense;
          }
        }
      ]
    }
  ]
};
